import * as React from "react";
import { selectBalancingFarmEventByEventType } from "../../balancingSelectors/selectBalancingFarmEvents";
import { IdStyles } from "../../less/IdStyles";
import { EventType } from "../balancing/types/BalancingCore";
import { ButtonPrimaryMedium } from "../generic/common/ButtonPrimaryMedium";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { ButtonGoto } from "./ButtonGoto";
export var EventThresholdAction = function (_a) {
    var eventId = _a.eventId, onCoopEventClick = _a.onCoopEventClick, onPlayerLeagueEventClick = _a.onPlayerLeagueEventClick;
    if (eventId === EventType.PlayerLeague || eventId === EventType.CoopLeague) {
        var isCoopLeague = eventId === EventType.CoopLeague;
        var openMenuHandler = isCoopLeague ? onCoopEventClick : onPlayerLeagueEventClick;
        var gotoButtonIcon = isCoopLeague ? IdIcon.CoopProjectIcn : IdIcon.ContractsMarketIcn;
        return (React.createElement(ButtonGoto, { onClick: openMenuHandler, buttonType: ButtonPrimaryMedium, destinationIcon: gotoButtonIcon }));
    }
    var balancingInfos = selectBalancingFarmEventByEventType(eventId);
    if (balancingInfos == undefined ||
        balancingInfos.displayInfo == undefined ||
        balancingInfos.displayInfo.locaKeyInstruction == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var locaKeyInstruction = balancingInfos.displayInfo.locaKeyInstruction;
    return (React.createElement("div", { className: IdStyles.CollectEventRewardsDescription + " flex flex--guts text-align-center" },
        React.createElement(TextLoca, { id: locaKeyInstruction, className: IdStyles.TextBoldPrimary })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventThresholdAction.tsx
// module id = 2771
// module chunks = 3